export const CopyIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect
      x="2.5"
      y="7.88086"
      width="13.2143"
      height="13.2143"
      rx="4.40476"
      stroke="white"
      stroke-width="1.5"
    />
    <path
      d="M15.2733 15.81H16.5947C19.0274 15.81 20.9994 13.8379 20.9994 11.4052V7.00047C20.9994 4.56778 19.0274 2.5957 16.5947 2.5957H12.1899C9.75724 2.5957 7.78516 4.56778 7.78516 7.00046V8.32189"
      stroke="white"
      stroke-width="1.5"
    />
  </svg>
);
